import { Component, OnInit } from '@angular/core';

import { HarpLoginService } from '@login/services/harp-login.service';
import { NavigationService } from '@login/services/navigation.service';
import { AlertService } from '@shared/services/alert.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

const UNEXPECTED_ERROR_MSG =
  'An unexpected error has occurred. Please try again later.';

@Component({
  selector: 'app-login-redirect-interim',
  templateUrl: './login-redirect-interim.component.html',
  styleUrls: ['./login-redirect-interim.component.scss'],
})
export class LoginRedirectInterimComponent implements OnInit {
  constructor(
    private harpLoginService: HarpLoginService,
    private navigationService: NavigationService,
    private alertService: AlertService,
    private router: Router,
    private cookieService: CookieService,
  ) {}

  ngOnInit() {
    // TODO: Uncomment for ESST1-5921
    // this.processEndpointEncodedQueryParams();

    this.checkSessionAndRedirect();
  }

  async checkSessionAndRedirect() {
    console.log('EXTRACT ID TOKEN FROM HERE');
    try {
      console.log('PIVCARD WINDOW LOCATION: ', window.location);
      console.log('PIVCARD WINDOW LOCATION HASH: ', window.location.hash);
      if (!window.location.hash && this.cookieService.get('pivcard')) {
        this.cookieService.delete('pivcard', '/');
        // redirect piv card holder directly to Okta since they don't need username/password
        this.harpLoginService.pivCardOktaRedirect();
        return;
      }

      const accessTokenHashKeyString = '#access_token=';
      // extract harp_token hash value from URL
      let harpToken = window.location.hash.substring(
        window.location.hash.indexOf(accessTokenHashKeyString) +
          accessTokenHashKeyString.length,
      );
      // remove any additional URL params after harp_token
      harpToken = harpToken.replace(/&.*/, '');

      // we set this here so it's accessible in check-session guard (currently Okta sets harp_token cookie as secure, making it not accessible)
      this.cookieService.set('harp_token_accessible', harpToken, { path: '/' });

      console.log('ID TOKEN FROM URL LLLLLLLLLLLLLLLLL: ', harpToken);

      const adoCookieValue = this.cookieService.get('ado');
      console.log(
        'ADO COOKIE VALUE AFTER REDIRECT BACK TO login-redirect-interim: ',
        adoCookieValue,
      );

      // if an ADO does exist
      if (adoCookieValue) {
        console.log('INSIDE 33355 - ADO');
        await this.harpLoginService.navigateToAdoHomePage(true);
        return;
      }

      this.navigationService.goToHomepage();
    } catch (err) {
      console.log('CATCH ERROR: ', JSON.stringify(err));
      this.alertService.setAlert(UNEXPECTED_ERROR_MSG);
    }
  }

  /**
   * NOTE: This is used as a workaround for Okta's improper handling
   * of redirect URIs with query params. This function reformats URLs
   * where the query params are encoded and tacked onto the path.
   *
   * Ex)
   *
   * https://sbx.harp.cms.gov/login/login-redirect-interim/ADO%3DHARP would redirect to
   * https://sbx.harp.cms.gov/login/login-redirect-interim?ADO=HARP
   */
  private processEndpointEncodedQueryParams() {
    const urlFragments = this.router.url.split('/');

    const queryParams = this.getEndpointEncodedQueryParams(
      decodeURIComponent(urlFragments[urlFragments.length - 1]),
    );

    if (queryParams) {
      this.router.navigate(['/login/login-redirect-interim'], {
        queryParams,
        queryParamsHandling: 'merge',
      });
    }
  }

  private getEndpointEncodedQueryParams(params) {
    return decodeURIComponent(params)
      ?.split('&')
      .reduce((acc, ele) => {
        const [param, value] = ele.split('=');
        return {
          ...acc,
          [param]: decodeURIComponent(value),
        };
      }, {});
  }
}
